import API from '../../util/api';

export default {
    getNotification(company_idx) {
        return API.get(`/member/notification`, {params: {company_idx: company_idx}});
    },
    notifyConfirm(idx) {
        return API.post(`/member/notification/${idx}`);
    },
    notifyDelete(idx) {
        return API.delete(`/member/notification/${idx}`);
    },
    getNotificationAlarm(params) {
        return API.get(`/member/notification/alarm`, { params });
    },
    getNotificationAlarmCompanies() {
        return API.get(`/member/notification/alarm/companies`);
    },
    getNotificationUnreadCount() {
        return API.get(`/member/notification/alarm/unread`);
    },
    notifyConfirmAlarm(notificationIds) {
        return API.post(`/member/notification/alarm`, { notification_ids: notificationIds });
    },
    notifyDeleteAlarm(notificationIds) {
        return API.delete(`/member/notification/alarm`, { data: { notification_ids: notificationIds } });
    },
    // 히스토리 알림 관련 API
    getNotificationHistory(params) {
        return API.get(`/member/notification/history`, { params });
    },
    getNotificationHistoryUnreadCount() {
        return API.get(`/member/notification/history/unread`);
    },
    markNotificationsAsRead(notificationIds) {
        return API.post(`/member/notification/history`, { notification_ids: notificationIds });
    },
    deleteNotifications(notificationIds) {
        return API.delete(`/member/notification/history`, { data: { notification_ids: notificationIds } });
    }
};
